import api from '@/lib/axios';
import type { OrgAffidavitRow } from '@/services/org-reports.api';

function unwrap<T>(r: { data: { data?: T } | T }): T {
  const body: any = r.data;
  return (body?.data ?? body) as T;
}

export interface UploadResult {
  url: string;
  name: string;
  size: number;
  mime: string;
}

export interface CreateAffidavitData {
  schoolId: string;
  studentId: string;
  studentSignatureUrl: string;
  guardianSignatureUrl: string;
}

export interface UpdateAffidavitData {
  schoolId: string;
  studentSignatureUrl?: string;
  guardianSignatureUrl?: string;
}

/** The write half of Affidavits — reading (list/filters/export) stays on `OrgReportsApi.affidavits()`, already built. */
export const OrgAffidavitsWriteApi = {
  upload: async (schoolId: string, file: File): Promise<UploadResult> => {
    const fd = new FormData();
    fd.append('file', file);
    return unwrap(await api.post('/org/affidavits/uploads', fd, { params: { schoolId } }));
  },

  create: async (data: CreateAffidavitData): Promise<OrgAffidavitRow> => unwrap(await api.post('/org/affidavits', data)),

  update: async (id: string, data: UpdateAffidavitData): Promise<OrgAffidavitRow> =>
    unwrap(await api.patch(`/org/affidavits/${id}`, data)),

  remove: async (id: string, schoolId: string): Promise<{ deleted: true; id: string }> =>
    unwrap(await api.delete(`/org/affidavits/${id}`, { params: { schoolId } })),
};
